import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Job, UserModel} from '../../../core/models';

@Component({
  selector: 'app-job-preview',
  templateUrl: './job-preview.component.html',
  styleUrls: ['./job-preview.component.css']
})
export class JobPreviewComponent implements OnInit {
  IMAGE_PLACEHOLDER = '../../../../../assets/images/img_placeholder.jpg';
  LOGO_PLACEHOLDER = '../../../../assets/images/avatar_placeholder.png';

  @Input() job: any;
  @Output() editImage = new EventEmitter<any>();

  user: UserModel;

  constructor() { }

  ngOnInit() {
  }

  onEditImageClick() {
    this.editImage.emit();
  }

}
